import { Currency } from '@/core/currency/interfaces';

const RSD: Currency = {
    name: 'Serbian Dinar',
    demonym: 'Serbian',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '941',
    symbol: 'din',
    symbolNative: 'дин',
    minorSingle: 'Para',
    minorPlural: 'Para',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'RSD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default RSD;
